<script>

    import { toast } from 'bulma-toast'
    import { userStore, creditsStore, notifyStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service.js'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    
    let loading = false

    let data = {
        processor: 'admin'
    }

    async function createCredit() {

        data.userId = $userStore._id

        loading = true
        const resp = await CreditsService.createCredit(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notifyStore.set('wallet_updated')
        creditsStore.append(resp.data)

        toast({message: 'Credito creado', type: 'is-success'})

        modalStore.close()
    }
</script>

<Form on:submit={ createCredit } { loading } >
    
    <InputNumber bind:value={ data.amount } label="Monto" placeholder="Monto" min=0 max=500000 />

    <div class="columns">
        <div class="column">
            <Select bind:value={ data.status } 
                label="Estatus"
                options={[
                    {value: 'paid', text: 'Pagado'},
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'free', text: 'Gratis'}
                ]}
            />
        </div>
        <div class="column">
            <InputText bind:value={data.reference} label="Referencia" placeholder="Referencia de pago" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave />
    </div>
    
</Form>